export const getHostname = (url) => {
  let result = url.match(/https?:\/\/[^\/]*/);
  let extractedString = result && result[0];
  return extractedString
}